// Board templates for "Neues Board" (feature catalogue A3): the frames a new board starts with.
// Own wording – no texts from other products. Applied once after the first sync of an empty board.
import type { FrameLayout } from "./engine-api";
import { defaultLayout, monthAfter, tableLayout } from "./frame-editor";
import { isoWeek } from "./iso";

export const DOMAINS = ["Mechanik", "Elektronik", "Software", "QM"];

const items = (titles: string[]) => titles.map((title) => ({ id: null, title }));

export const TEMPLATES: Record<string, { name: string; frames: () => FrameLayout[] }> = {
  leer: { name: "Leeres Board", frames: () => [] },
  sprint: { name: "Sprint", frames: () => [defaultLayout(DOMAINS)] },
  masterplan: {
    name: "Sprint & Masterplan",
    frames: () => {
      const now = isoWeek(new Date());
      return [{
        title: "Sprint & Masterplan", start: now, weeks: 6, masterplan: monthAfter(now.year, now.week, 6), months: 6,
        backlog: true, lanes: items(DOMAINS), columns: [],
      }];
    },
  },
  tabelle: { name: "Tabelle", frames: () => [{ ...tableLayout(), title: "Strategie", lanes: items(["Ziel 1", "Ziel 2", "Ziel 3"]), columns: items(["Ziel", "Massnahmen", "Kennzahl", "Status"]) }] },
  meeting: {
    name: "Team-Meeting",
    frames: () => [{
      title: "Team-Meeting", start: null, weeks: 0, masterplan: null, months: 0, backlog: false,
      lanes: items(["Informationen", "Diskussion", "Entscheide"]), columns: items(["Thema", "Ergebnis", "Nächste Schritte"]),
    }],
  },
};

/** Horizontal gap between the frames of a template (board px). */
export const FRAME_GAP = 200;
